import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { api } from "@/lib/api";
import { FadeUp, Overline } from "@/components/site/Reveal";

export default function FaqPage() {
  const [faqs, setFaqs] = useState(null);

  useEffect(() => {
    api.get("/faqs").then((d) => setFaqs(d.data)).catch(() => setFaqs([]));
  }, []);

  return (
    <div className="pt-28 sm:pt-32" data-testid="faq-page">
      <header className="mx-auto max-w-3xl px-6">
        <Overline className="text-terra">FAQ</Overline>
        <h1 className="font-display mt-3 text-4xl font-extrabold tracking-tight text-forest-700 sm:text-5xl" data-testid="faq-title">
          Questions we hear at every kitchen table.
        </h1>
      </header>

      <section className="mx-auto max-w-3xl px-6 py-14" data-testid="faq-list">
        {faqs === null ? (
          <div className="space-y-3">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="h-16 animate-pulse rounded-lg bg-sage" />
            ))}
          </div>
        ) : (
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem key={f.id} value={f.id} data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="font-display text-left text-lg font-bold text-forest-700 hover:text-terra hover:no-underline">
                  {f.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-moss">
                  {f.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        )}
      </section>

      <section className="mx-auto max-w-3xl px-6 pb-24">
        <FadeUp>
          <div className="flex flex-col items-start justify-between gap-6 rounded-xl border border-forest-700/10 bg-bone-dark p-8 sm:flex-row sm:items-center">
            <div>
              <h2 className="font-display text-xl font-bold text-forest-700">Still stuck?</h2>
              <p className="mt-1 text-sm text-moss">Book a free site inspection and ask us in person.</p>
            </div>
            <Link
              to="/book-inspection"
              data-testid="faq-cta-inspection"
              className="inline-flex items-center gap-2 rounded-full bg-terra px-6 py-3 text-sm font-bold text-bone transition-colors hover:bg-terra-dark"
            >
              Book a free inspection <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </FadeUp>
      </section>
    </div>
  );
}
